var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditReviewerDisabledIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8232",
    "data-name": "Group 8232",
    transform: "translate(-129.982 -209.475)",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3557",
    "data-name": "Rectangle 3557",
    width: 30,
    height: 30,
    transform: "translate(129.982 209.475)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8229",
    "data-name": "Group 8229",
    transform: "translate(147.783 215.192)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3558",
    "data-name": "Rectangle 3558",
    width: 5.956,
    height: 7.672,
    rx: 2.432,
    transform: "translate(2.647)",
    fill: "none",
    stroke: "#948b9e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3644",
    "data-name": "Path 3644",
    d: "M153.9,223.236h-5.5a2.6,2.6,0,0,0-2.6,2.6v4.18a1.573,1.573,0,0,0,1.574,1.572h8.1a1.572,1.572,0,0,0,1.572-1.572v-3.64A3.141,3.141,0,0,0,153.9,223.236Z",
    transform: "translate(-145.797 -213.415)",
    fill: "none",
    stroke: "#948b9e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8230",
    "data-name": "Group 8230",
    transform: "translate(131.327 215.192)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3559",
    "data-name": "Rectangle 3559",
    width: 5.956,
    height: 7.672,
    rx: 2.432,
    transform: "translate(2.646)",
    fill: "none",
    stroke: "#948b9e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3645",
    "data-name": "Path 3645",
    d: "M139.28,223.236h-5.5a2.6,2.6,0,0,0-2.6,2.6v4.18a1.572,1.572,0,0,0,1.572,1.572h8.1a1.572,1.572,0,0,0,1.572-1.572v-3.64A3.142,3.142,0,0,0,139.28,223.236Z",
    transform: "translate(-131.177 -213.415)",
    fill: "none",
    stroke: "#948b9e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8231",
    "data-name": "Group 8231",
    transform: "translate(143.117 217.413)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_680",
    "data-name": "Line 680",
    x2: 3.896,
    transform: "translate(0 1.605)",
    fill: "none",
    stroke: "#948b9e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3646",
    "data-name": "Path 3646",
    d: "M144,216.484l1.384,1.384a.325.325,0,0,1,0,.46L144,219.713",
    transform: "translate(-141.357 -216.484)",
    fill: "none",
    stroke: "#948b9e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditReviewerDisabledIcon);
export default __webpack_public_path__ + "static/media/edit-reviewer-disabled-icon.2ce44bb22735bcf6a37c4d5e003fd913.svg";
export { ForwardRef as ReactComponent };